import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Shards } from '@sorare/core/src/atoms/icons/Shards';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, BrandM, BrandXS } from '@sorare/core/src/atoms/typography';
import { TextureBackground } from '@sorare/core/src/atoms/ui/TextureBackground';
import { Bezel } from '@sorare/core/src/atoms/ui/bezels/Bezel';
import { range } from '@sorare/core/src/lib/arrays';

const Content = styled.div`
  padding: var(--triple-unit) var(--quadruple-unit);
`;
const Slot = styled(Horizontal).attrs({ center: true })`
  width: calc(8 * var(--unit));
  max-width: calc(20% - var(--double-unit));
  aspect-ratio: var(--card-aspect-ratio);
  border-radius: var(--unit);
  border: 1px solid var(--c-nd-150);
  background: var(--c-black);
`;
const PartiallyFilledSlot = styled(Slot)`
  position: relative;
  isolation: isolate;
  filter: drop-shadow(0 0 2px rgba(var(--c-rgb-limited), 0.6));

  &::before {
    content: '';
    border-radius: inherit;
    position: absolute;
    inset: 0;
    border: 1px solid var(--c-limited-secondary);
    clip-path: polygon(0% 65%, 100% 65%, 100% 100%, 0% 100%);
  }
`;

const StyledTextureBackground = styled(TextureBackground)`
  position: absolute;
  inset: 0;
  z-index: -1;
`;

export const CompleteLimitedLineup = () => {
  return (
    <Bezel borderColor="rgba(var(--c-rgb-limited), 0.3)">
      <StyledTextureBackground
        background="missions"
        mode="dark"
        color={['var(--c-limited-secondary)', 'var(--c-limited)']}
        imageOpacity={0.3}
        withDots
      />
      <Content className="text-center">
        <Vertical center gap={2}>
          <Vertical center>
            <FormattedMessage
              id="IntroducingRoadToPro.completeLimitedLineup.title"
              defaultMessage="<em>Complete</em><label>your first Limited Lineup</label>"
              values={{
                em: chunks => <BrandM>{chunks}</BrandM>,
                label: chunks => (
                  <BodyM color="var(--c-nd-600)">{chunks}</BodyM>
                ),
              }}
            />
          </Vertical>
          <Horizontal center>
            <PartiallyFilledSlot>
              <Vertical center>
                <Shards />
                <BrandXS>350</BrandXS>
              </Vertical>
            </PartiallyFilledSlot>
            {range(4).map(i => {
              return (
                <Slot key={i}>
                  <Shards color="var(--c-nd-600)" />
                </Slot>
              );
            })}
          </Horizontal>
        </Vertical>
      </Content>
    </Bezel>
  );
};
